// Genere par tools/gen-icons.mjs. Ne pas editer a la main.
import { createRemixIcon } from '../create-remix-icon.js';

export const IconCameraVideo = createRemixIcon('IconCameraVideo', "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.5 11.5a5 5 0 1 0 0-10a5 5 0 0 0 0 10m10.5 0a3.5 3.5 0 1 0 0-7a3.5 3.5 0 0 0 0 7M4.75 12.75h14.5v10.5H4.75zm2.5 2.5v5.5h9.5v-5.5zm13.5-.25v6h2.5v-6z\" clip-rule=\"evenodd\"/>");
